module.exports = __webpack_public_path__ + "img/horst.41b26a7a.jpg";